import React from 'react';

const webDesignPortfolioItems = [
  {
    id: 1,
    image: '/assets/images/web-design/web (1).png',
    title: 'Horizon Luxury Resorts',
    category: 'Hospitality & Travel',
    platform: 'Custom Web Design'
  },
  {
    id: 2,
    image: '/assets/images/web-design/web (2).png',
    title: 'Amore Boutique Brand',
    category: 'Fashion & Luxury',
    platform: 'Responsive UI/UX'
  },
  {
    id: 3,
    image: '/assets/images/web-design/web (3).png',
    title: 'Apex Cloud Systems',
    category: 'Technology & SaaS',
    platform: 'Corporate Portal'
  },
  {
    id: 4,
    image: '/assets/images/web-design/web (4).png',
    title: 'Nafees Global Mobility',
    category: 'Transportation & Auto',
    platform: 'Enterprise Web Design'
  },
  {
    id: 5,
    image: '/assets/images/web-design/web (5).png',
    title: 'Guiltless Lifestyle Store',
    category: 'Health & Wellness',
    platform: 'Modern Web Design'
  },
  {
    id: 6,
    image: '/assets/images/web-design/web (6).png',
    title: 'Vanguard Media Studio',
    category: 'Creative & Agency',
    platform: 'Interactive UI/UX'
  },
  {
    id: 7,
    image: '/assets/images/web-design/web (7).png',
    title: 'Shaykis Global Brand',
    category: 'Consumer Brand',
    platform: 'Dynamic Web Design'
  },
  {
    id: 8,
    image: '/assets/images/web-design/web (8).png',
    title: 'Trends Alley Digital',
    category: 'Digital Marketplace',
    platform: 'High-Converting Web'
  }
];

function WebDesignPortfolio() {
  const handleConsultationClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('webdesign-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="ecom-portfolio-section">
      <div className="container">
        {/* Section Header */}
        <div className="ecom-portfolio-header">
          <div className="ecom-portfolio-badge-row">
            <span className="ecom-portfolio-badge">Featured Work & Masterpieces</span>
            <div className="ecom-portfolio-badge-line"></div>
          </div>

          <h2 className="ecom-portfolio-title">
            Website Design <span className="text-red">Portfolio</span>
          </h2>

          <p className="ecom-portfolio-subtitle">
            Explore our curated showcase of bespoke, high-converting websites designed for modern brands. Hover over any design to explore full page layout from top to bottom.
          </p>
        </div>

        {/* Portfolio 4-Column Grid matching Ecommerce Portfolio */}
        <div className="ecom-portfolio-grid">
          {webDesignPortfolioItems.map((item) => (
            <div key={item.id} className="ecom-portfolio-card" onClick={handleConsultationClick}>
              {/* Browser Window Frame Header */}
              <div className="ecom-portfolio-window-bar">
                <div className="ecom-window-dots">
                  <span className="ecom-dot dot-red"></span>
                  <span className="ecom-dot dot-yellow"></span>
                  <span className="ecom-dot dot-green"></span>
                </div>
                <span className="ecom-window-title">{item.platform}</span>
              </div>

              {/* Scrollable Image Frame */}
              <div className="ecom-portfolio-img-frame">
                <img 
                  src={item.image} 
                  alt={item.title} 
                  className="ecom-portfolio-img"
                  loading="lazy"
                />

                {/* Hover Hint Overlay */}
                <div className="ecom-hover-hint">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="7 13 12 18 17 13" />
                    <polyline points="7 6 12 11 17 6" />
                  </svg>
                  <span>Auto-scrolling</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WebDesignPortfolio;
